import tw from 'twin.macro'

export const MainContainer = tw.div`h-screen`

export const MainContent = tw.div`w-full`
